import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Trophy, TrendingUp, Activity, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Profile() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="46" id="heatinginstallationvisuals" ref={sectionRef} className="relative min-h-[800px] w-full overflow-hidden bg-background py-20 lg:py-32 flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-[-20%] right-[-10%] h-[800px] w-[800px] rounded-full bg-primary/10 opacity-40 blur-[120px] animate-pulse" />
        <div className="absolute bottom-[-20%] left-[-10%] h-[600px] w-[600px] rounded-full bg-secondary/5 opacity-30 blur-[100px]" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/noise_texture.png)] opacity-5 mix-blend-overlay" />
      </div>

      <div className="container relative z-10 mx-auto px-6">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr] lg:items-center">
          
          {}
          <div className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <div className="space-y-4">
              <h1 className="text-6xl font-extrabold tracking-tight text-foreground sm:text-7xl lg:text-8xl">
                CZYSTA <span className="text-primary">INSTALACJA</span>
              </h1>
              <p className="max-w-2xl text-xl text-muted-foreground sm:text-2xl leading-relaxed">Profesjonalne płukanie systemów CO. Usuwamy osady i kamień, przywracając pełną sprawność Twojego ogrzewania.</p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-14 px-8 text-lg font-bold bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
                <Link to="/ContactPage">
                  Zamów Czyszczenie
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-8 flex items-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-2 !h-[40px]">
                <Activity className="h-5 w-5 text-primary" />
                <span className="!text-3xl">Wyższa Wydajność</span>
              </div>
              <div className="flex items-center gap-2 !h-[40px]">
                <Trophy className="h-5 w-5 text-primary" />
                <span className="!text-3xl">Niższe Rachunki</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative flex justify-center perspective-1000 transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -z-10 h-[120%] w-[120%] -translate-x-1/2 -translate-y-1/2 bg-gradient-to-b from-primary/20 to-transparent blur-3xl" />

            <div className="group relative w-full max-w-md transform transition-transform duration-500 hover:scale-[1.02] hover:rotate-0 sm:rotate-y-[-12deg] sm:rotate-x-[6deg]">
              <Card className="overflow-hidden border-border bg-card/80 backdrop-blur-md shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
                
                <CardHeader className="relative border-b border-border pb-6">
                  <div className="flex items-center gap-4">
                    <div className="relative">
                      <SafeHydrate><Avatar className="h-20 w-20 border-2 border-primary shadow-lg">
                        <AvatarImage src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/avatar_player_alex.png" alt="Hydroflush Serwis" />
                        <AvatarFallback>HF</AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="absolute -bottom-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground font-bold shadow-md">
                        A+
                      </div>
                    </div>
                    <div>
                      <CardTitle className="text-2xl text-foreground">Status Systemu</CardTitle>
                      <CardDescription className="text-muted-foreground">Monitoring Hydroflush</CardDescription>
                      <div className="mt-2 flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary w-fit">
                        <span className="relative flex h-2 w-2">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                        </span>
                        System Drożny
                      </div>
                    </div>
                  </div>
                </CardHeader>

                <CardContent className="relative grid grid-cols-2 gap-4 pt-6">
                  <div className="rounded-xl bg-muted/50 p-4 text-center border border-border">
                    <div className="mb-1 text-sm text-muted-foreground">Odzysk Ciepła</div>
                    <div className="text-3xl font-bold text-foreground">98%</div>
                    <div className="mt-1 flex items-center justify-center gap-1 text-xs text-primary">
                      <TrendingUp className="h-3 w-3" />
                      <span>+15.2%</span>
                    </div>
                  </div>
                  <div className="rounded-xl bg-muted/50 p-4 text-center border border-border">
                    <div className="mb-1 text-sm text-muted-foreground">Przepływ</div>
                    <div className="text-3xl font-bold text-foreground">Max</div>
                    <div className="mt-1 text-xs text-muted-foreground">Bez Osadów</div>
                  </div>
                </CardContent>

                <CardFooter className="relative border-t border-border bg-muted/20 pt-4">
                  <div className="flex w-full items-center justify-between text-sm">
                    <span className="text-muted-foreground">Zalecany Serwis</span>
                    <span className="font-medium text-foreground">Jesień 2029</span>
                  </div>
                </CardFooter>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}